<style lang="less" scoped>
@import url('./index.less');
</style>

<template>
  <div class="disclamier">
    <div>
      <div><Header /></div>
      <div class="section">
        <div v-for="(item,index) in listData" :key="index">
          <h2>{{item.title}}</h2>
          <p v-for="(pitem,index) in item.paragraph" :key="index" v-html="pitem"></p>
        </div>
        <div class="message">
          <p>本网站联系方式：15267048843</p>
          <p>电子邮箱：liyx@hsmap.com</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from '@/components/Header'
export default {
  data() {
    return {
      listData:[
        {
          title:'第一条 协议订立',
          paragraph:[
            '1.1用户在同意本网站“火石战疫助手：非新冠肺炎患者资讯平台” <a style="color:#2d8cf0;" href="https://assistant-of-fighting-covid-19.hsmap.com">(https://assistant-of-fighting-covid-19.hsmap.com)</a> 的免责协议后，方可使用本网络服务平台(以下简称“平台”)提供的相关资讯及服务(以下简称“服务”)。',
            '1.2用户在使用本平台提供的服务前请务必认真阅读本协议，一旦用户使用本平台提供的服务即表示用户同意与本平台签订本协议且同意受本协议之约束。'
          ]
        },
        {
          title:'第二条 服务说明',
          paragraph:[
            '2.1 火石战疫助手：非新冠肺炎患者资讯平台所载的资讯均出于在疫情期间，为公众传播有益信息及患者教育的公益性目的。火石数智致力于通过该平台为非新冠肺炎的其他患者提供合理、准确、完整的资讯信息，为专业医学人士提供新冠肺炎的文献、临床、指南专业解读等。',
            '2.2 除特别注明禁止转载的文章外，欢迎公益性网站转载本平台资源，但转载时务必注明出处为“火石数智”，如有可能，请做好本平台的链接。对于商业性实体，如无本平台明确许可，不得非法使用本平台资源。',
            '2.3 凡本平台转载的所有文章、图片、资讯、音频、视频等资料的版权归版权所有人所有，本平台采用的非原创文章及图片等内容无法一一和版权人联系，如果所选内容的版权人认为该内容不宜在本平台中展示，或不应无偿使用，请及时使用电子邮件或电话通知我们，以便本平台迅速采取适当行动，避免造成不必要的损失。',
            '2.4 直播/义诊等内容以各机构在各大官方发布信息为准(认证微博、官方微信公众号、医院盖章文件等)，平台只做内容收集展示及部分人工核实。',
            '2.5 文献、指南、临床研究的内容经过火石专业医学团队提取、处理及统计分析，并在文中注明了原信息来源。各分析维度由本平台医学团队定义，非权威发布，如存在偏差请尽快通知我们，最终解释权归本平台所有。'
          ]
        },
        {
          title:'第三条 用户的权利和义务',
          paragraph:[
            '3.1 用户使用本平台前，应仔细阅读各方具体信息。本平台中涉及的内容，如有与我国相关法律冲突的，以我国相关法律为准。',
            '3.2 用户在使用平台的推荐等功能时，默认获取所在地理位置后进行就近医院信息推荐。',
            '3.3 用户在使用对话小智功能时，由智能AI进行问题解答，如仍无法解决困惑可通过发布问题的形式寻求专业人士的帮助。',
            '3.4 用户通过此平台跳转至其他平台后，所享受的权利和应遵守的义务均参照第三方平台的相应规定。',
            '3.5 如用户期望通过本平台进行信息的发布，可以通过电子邮件或电话及时与我们联系。',
            '3.6 平台的问答、疾病科普及对话小智等模块内容仅作为参考之用。平台致力于提供正确、完整的健康资讯，但因信息的错综复杂和每个用户的差异性等原因，平台无法保证信息的绝对正确和完整性，平台不对因信息不正确或遗漏所导致的任何损失或损害承担责任。平台提供的任何健康资讯不能替代医生和其他医务人员的建议，如自行使用相应资料发生偏差，本平台不承担任何法律责任',
          ]
        },
        {
          title:'第四条 免责说明',
          paragraph:[
            '4.1 在本平台内凡注明“火石原创”的所有文字、图片、音频、视频稿件及其他内容等均属本平台原创内容，任何媒体、网站或个人未经本平台许可，不得转载、链接、转贴或以其他方式复制发表。',
            '4.2 凡本平台转载的所有文章、图片、资讯、音频、视频等资料的版权归版权所有人所有，本平台采用的非原创文章及图片等内容无法一一和版权者联系，如果所选内容的版权人认为该内容不宜在本平台中展示，或不应无偿使用，请及时使用电子邮件或电话通知我们，以便本平台迅速采取适当行动，避免造成不必要的损失。',
            '4.3 对于用户进行的信息发布，如因用户提供错误信息所导致的损失，由用户自行承担，本平台不承担任何责任',
            '4.4 用户充分知晓并认可，本平台仅为公益性信息传播平台，凡以任何方式登录本平台或直接、间接使用本平台资料者，视为自愿接受本网站声明的约束。',
            '4.5 本平台会尽力维护平台信息的安全，但法律规定的不可抗力，以及因为黑客入侵、计算机病毒等原因造成用户资料泄露、丢失、被盗用、被篡改的，本平台不承担任何责任。',
            '4.6 本平台如被恶意篡改用于不法信息传递，一律追责。',
            '4.7 本平台唯一官方网址<a style="color:#2d8cf0;" href="https://assistant-of-fighting-covid-19.hsmap.com">(https://assistant-of-fighting-covid-19.hsmap.com)</a>(火石战疫助手：非新冠肺炎患者资讯平台)如被人恶意假借名义进行不正当行为，与本平台无关。但本平台保留追究其法律责任的权利。',
          ]
        },
        {
          title:'第五条 争议解决及法律适用',
          paragraph:[
            '5.1 在平台使用过程中如发生争议，用户同意按照中华人民共和国现行有效的相关法律法规来解决争议，并同意接受平台方所在地浙江省杭州市滨江区有管辖权的人民法院的管辖。',
          ]
        },
      ]
    }
  },
  components:{
    Header
  }
}
</script>